export const RTL_LANGUAGES = ['ar'];

// Language options used across the app (must stay in sync with i18n supportedLngs)
export const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'fr', label: 'Français' },
  { value: 'es', label: 'Español' },
  { value: 'de', label: 'Deutsch' },
  { value: 'zh', label: '中文' },
  { value: 'ar', label: 'العربية' },
];

// Return a human‑readable language name for a code like "en" or "en-US"
export const getLanguageName = (lng) => {
  if (!lng) return '';
  const langCode = String(lng).split('-')[0];
  const match = LANGUAGE_OPTIONS.find((opt) => opt.value === langCode);
  return match?.label || lng;
};